export class EmwerxConsoleError extends Error {
  message: string;
  notification: string;
  constructor(message: string, notification?: string) {
    super(message);
    this.message = message;
    this.notification = notification ?? message;
  }
}

export class APIError extends EmwerxConsoleError {
  // The HTTP status code, when the error came from an HTTP response.
  status?: number;
  constructor(message: string, notification: string, status?: number) {
    super(message, notification);
    this.name = 'APIError';
    this.status = status;
  }
}

export class AuthError extends EmwerxConsoleError {
  constructor(message: string, notification: string) {
    super(message, notification);
    this.name = 'AuthError';
  }
}

export class ValidationError extends EmwerxConsoleError {
  constructor(message: string, notification?: string) {
    super(message, notification);
    this.name = 'ValidationError';
  }
}

export class APINotFoundError extends APIError {
  constructor(message: string, notification: string, status?: number) {
    super(message, notification, status);
    this.name = 'APINotFoundError';
  }
}

export class APIBadRequestError extends APIError {
  constructor(message: string, notification: string, status?: number) {
    super(message, notification, status);
    this.name = 'APIBadRequestError';
  }
}

export class APIForbiddenError extends APIError {
  constructor(message: string, notification: string, status?: number) {
    super(message, notification, status);
    this.name = 'APIForbiddenError';
  }
}

export class APIConflictError extends APIError {
  constructor(message: string, notification: string, status?: number) {
    super(message, notification, status);
    this.name = 'APIConflictError';
  }
}
